const IBAN_INVALID_MESSAGE = 'Vul een geldig IBAN-nummer in.'

export function isIbanFieldName (name) {
  return typeof name === 'string' && /^iban/i.test(name)
}

export function normalizeIbanValue (value) {
  if (!value) {
    return value
  }
  return value.toUpperCase().replace(/[\s-]/g, '')
}

export function isValidIban (value) {
  const iban = normalizeIbanValue(value)
  if (!iban) {
    return true
  }
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban) || iban.length < 15 || iban.length > 34) {
    return false
  }

  const rearranged = iban.slice(4) + iban.slice(0, 4)
  let numeric = ''
  for (const char of rearranged) {
    numeric += (/[A-Z]/.test(char) ? (char.charCodeAt(0) - 55).toString() : char)
  }

  let remainder = 0
  for (let i = 0; i < numeric.length; i += 7) {
    remainder = parseInt(String(remainder) + numeric.slice(i, i + 7), 10) % 97
  }

  return remainder === 1
}

export { IBAN_INVALID_MESSAGE }
